import styled from 'styled-components/native';

const ScrollView = styled.ScrollView``;

export default ScrollView;
